import React, { useEffect } from 'react';
import './Modal.css';

const PrivacyModal = ({ closeModal }) => {
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = ''; };
    }, []);

    return (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && closeModal()}>
            <div className="modal-box" style={{ maxWidth: '800px', maxHeight: '85vh' }}>
                <button className="modal-close" onClick={closeModal}>×</button>
                <div className="modal-header">
                    <h2>Privacy Policy</h2>
                    <img src="/assets/Embracelogo.png" alt="Embrace" />
                </div>
                
                <div style={{ paddingRight: '10px', fontSize: '14px', lineHeight: '1.6', color: 'var(--mid-gray)', textAlign: 'left' }}>
                    <p style={{ marginBottom: '15px' }}><strong>Last Updated: {new Date().toLocaleDateString()}</strong></p>
                    
                    <p style={{ marginBottom: '15px' }}>At Embrace Beauty Aesthetics, your privacy is a top priority. This Privacy Policy outlines how we collect, use, and protect your personal information when you visit our website or use our services.</p>
                    
                    <h3 style={{ fontSize: '18px', color: 'var(--dark)', marginTop: '20px', marginBottom: '10px' }}>1. Information We Collect</h3>
                    <p style={{ marginBottom: '15px' }}>We may collect personal information such as your name, email address, phone number, and appointment details when you fill out forms on our website or contact us directly.</p>
                    
                    <h3 style={{ fontSize: '18px', color: 'var(--dark)', marginTop: '20px', marginBottom: '10px' }}>2. How We Use Your Information</h3>
                    <p style={{ marginBottom: '15px' }}>Your information is used to schedule appointments, respond to inquiries, send you updates about our services, and improve the overall client experience. We do not sell your personal data to third parties.</p>
                    
                    <h3 style={{ fontSize: '18px', color: 'var(--dark)', marginTop: '20px', marginBottom: '10px' }}>3. Data Security</h3>
                    <p style={{ marginBottom: '15px' }}>We implement industry-standard security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.</p>
                    
                    <h3 style={{ fontSize: '18px', color: 'var(--dark)', marginTop: '20px', marginBottom: '10px' }}>4. Your Rights</h3>
                    <p style={{ marginBottom: '15px' }}>You have the right to access, update, or request the deletion of your personal information at any time. If you wish to exercise these rights, please contact us.</p>
                    
                    <h3 style={{ fontSize: '18px', color: 'var(--dark)', marginTop: '20px', marginBottom: '10px' }}>5. Contact Us</h3>
                    <p style={{ marginBottom: '15px' }}>If you have any questions or concerns about this Privacy Policy, please contact us at +1 469-434-1574.</p>
                </div>
            </div>
        </div>
    );
};

export default PrivacyModal;
